import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutModule } from '@angular/cdk/layout';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxHeadroomModule } from 'ngx-headroom';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgpSortModule } from 'ngp-sort-pipe';

import { StripHtmlPipe } from './shared/pipes/strip.html.pipe';
import { SanitizeHtmlPipe } from './shared/pipes/sanitize.html.pipe';
import { Safe } from './shared/pipes/safe.html.pipe';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { DirectoryComponent } from './directory/directory.component';
import { ListingComponent } from './directory/listing/listing.component';
import { NavComponent } from './shared/layout/nav/nav.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { HeroComponent } from './home/hero/hero.component';
import { HomeDirectoryComponent } from './home/home-directory/home-directory.component';
import { ProfileBiographyComponent } from './profile/profile-biography/profile-biography.component';
import { ProfileCertificationComponent } from './profile/profile-certification/profile-certification.component';
import { ProfileDegreeComponent } from './profile/profile-degree/profile-degree.component';
import { ProfileHonorComponent } from './profile/profile-honor/profile-honor.component';
import { ProfileInterestComponent } from './profile/profile-interest/profile-interest.component';
import { ProfileJournalComponent } from './profile/profile-journal/profile-journal.component';
import { ProfileLicensureComponent } from './profile/profile-licensure/profile-licensure.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ProfileSkeletonComponent } from './profile/profile-skeleton/profile-skeleton.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PlainTextPipe } from './shared/pipes/plain-text.pipe';

@NgModule({
  declarations: [
    AppComponent,
    StripHtmlPipe,
    SanitizeHtmlPipe,
    Safe,
    PlainTextPipe,
    HomeComponent,
    NavComponent,
    FooterComponent,
    ProfileComponent,
    DirectoryComponent,
    ListingComponent,
    HeroComponent,
    HomeDirectoryComponent,
    ProfileBiographyComponent,
    ProfileCertificationComponent,
    ProfileDegreeComponent,
    ProfileHonorComponent,
    ProfileInterestComponent,
    ProfileJournalComponent,
    ProfileLicensureComponent,
    PageNotFoundComponent,
    ProfileSkeletonComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    CommonModule,
    LayoutModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxHeadroomModule,
    FontAwesomeModule,
    NgpSortModule,
    NgxSkeletonLoaderModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
